import React from 'react';
import SvgIcon from './svgIcon';

const SvgPieChart = props => {
  return (
    <SvgIcon width={24.377} height={24.377} {...props}>
      <g
        strokeLinejoin="round"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2px"
      >
        <path
          d="M47.3 172.464a10.513 10.513 0 0 1-4.939 1.213 13.324 13.324 0 0 1-6.378-1.926"
          transform="translate(-30.176 -150.3)"
        />
        <path
          d="M170.79 35.445a13.4 13.4 0 0 1 2.2 6.368 11.984 11.984 0 0 1-2.367 6.943"
          transform="translate(-149.614 -29.624)"
        />
        <path
          d="M2.58 18.048A11.77 11.77 0 0 1 1 12.189a11.19 11.19 0 0 1 10.045-11.13A11.325 11.325 0 0 1 12.188 1q.377 0 .748.024a8.816 8.816 0 0 1 4.7 1.645"
          transform="translate(0 -.001)"
        />
      </g>
    </SvgIcon>
  );
};

export default SvgPieChart;
